import React from 'react';
import { Button, Dropdown, Form } from 'react-bootstrap';
import {
  parseAssemblyMultiSelectValue,
  serializeAssemblyMultiSelectValue,
} from './assemblyScheduleConfig';

const AssemblyMultiSelect = ({
  value,
  options,
  onChange,
  disabled = false,
  forceOpen = false,
  onApply,
  onCancel,
}) => {
  const selectedValues = parseAssemblyMultiSelectValue(value);
  const selectedKeys = new Set(selectedValues.map((item) => item.toLowerCase()));

  const toggleOption = (option, checked) => {
    const next = checked
      ? [...selectedValues, option]
      : selectedValues.filter((item) => item.toLowerCase() !== option.toLowerCase());
    onChange(serializeAssemblyMultiSelectValue(next));
  };

  return (
    <Dropdown autoClose="outside" show={forceOpen ? true : undefined} className="assembly-multi-select">
      <Dropdown.Toggle variant="outline-secondary" size="sm" disabled={disabled}>
        <span>{selectedValues.length > 0 ? selectedValues.join(', ') : 'Select assembler(s)…'}</span>
      </Dropdown.Toggle>
      <Dropdown.Menu className="assembly-multi-select-menu">
        {options.length === 0 ? (
          <Dropdown.ItemText className="text-muted">No assembler options configured.</Dropdown.ItemText>
        ) : options.map((option) => (
          <Form.Check
            key={option}
            id={`assembly-assembler-${option.replace(/[^a-z0-9]/gi, '-')}`}
            className="assembly-multi-select-option"
            type="checkbox"
            label={option}
            checked={selectedKeys.has(option.toLowerCase())}
            disabled={disabled}
            onChange={(event) => toggleOption(option, event.target.checked)}
          />
        ))}
        {forceOpen && (
          <div className="assembly-multi-select-actions">
            <Button size="sm" variant="outline-secondary" onClick={onCancel}>Cancel</Button>
            <Button size="sm" onClick={onApply} disabled={disabled}>Apply</Button>
          </div>
        )}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AssemblyMultiSelect;
